import { useQuery } from '@tanstack/vue-query';
import { Ref, ref, watch } from 'vue';

import personApi from '~/services/person-api/person-api';
import { PersonAPI } from '~/services/person-api/person-api.types';

import { queryKeys } from '../queryClient';

export interface UseUsersParams extends PersonAPI.UsersRequestParams {}

export default function useUsers(params: Ref<UseUsersParams>) {
  const queryKey = ref(queryKeys.USERS.LIST(params.value));

  const queryFn = async () => {
    const res = await personApi.user.list(params.value);
    return res;
  };

  const query = useQuery({
    queryFn,
    queryKey,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  watch(params, (newParams) => {
    queryKey.value = queryKeys.USERS.LIST(newParams);
    query.refetch();
  }, { deep: true, immediate: true });
  return query;
}
